import './polyfills';
import { createRoot } from 'react-dom/client';
import 'typeface-roboto';
import App from './App';

import './index.css';

import * as serviceWorker from './serviceWorker';
import { PublicClientApplication, EventType } from '@azure/msal-browser';
import { msalConfig } from './authConfig';
// import { AccountInfo } from '@azure/msal-common';

const msalInstance = new PublicClientApplication(msalConfig);
console.log(msalInstance.getAllAccounts());

if (!msalInstance.getActiveAccount() && msalInstance.getAllAccounts().length > 0) {
    // Account selection logic is app dependent. Adjust as needed for different use cases.
    msalInstance.setActiveAccount(msalInstance.getActiveAccount()[0]);
}

msalInstance.addEventCallback((event) => {
    // @ts-ignore
    if (event.eventType === EventType.LOGIN_SUCCESS && event.payload && event.payload.account) {
        // @ts-ignore
        const account = event.payload.account;
        msalInstance.setActiveAccount(account);
    }
});

const container = document.getElementById('root');
const root = createRoot(container);

root.render(<App instance={msalInstance} />);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
